export const COMPONENT_CONTEXT_MENU = "COMPONENT_CONTEXT_MENU";
export const NAVIGATION_CONTEXT_MENU = "NAVIGATION_CONTEXT_MENU";
